import type { Building } from "building-types/building/buildingTypes";
import type { Room } from "building-types/rooms/roomTypes";
import type { WorldInches } from "common/types/nominalNumbersTypes";
import { assertIsNotNullOrUndefined } from "common/utils/assertOfType";
import { floorAssemblyTop } from "doc/elements/floor/floorAssembly";
import { planeByThreePoints } from "geom/plane";
import { collectFromLevels } from "../elements/datumsLevelUtils";
import memo from "../utils/memo";

function select({
  roomFloorAssemblies,
  levels,
  levelsAttributes,
  rooms,
  datumAbstractions,
}: Pick<Building, "roomFloorAssemblies" | "levels" | "levelsAttributes" | "rooms" | "datumAbstractions">) {
  return {
    roomFloorAssemblies,
    levels,
    levelsAttributes,
    rooms,
    datumAbstractions,
  };
}

function generate({
  roomFloorAssemblies,
  levels,
  levelsAttributes,
  rooms,
  datumAbstractions,
}: ReturnType<typeof select>): {
  resolvedDatums: Building["resolvedDatums"];
} {
  const resolvedDatums = collectFromLevels(levels, levelsAttributes, datumAbstractions);

  const roomFloorElevation = ({ id, level: roomLevel }: Room): WorldInches =>
    floorAssemblyTop(roomFloorAssemblies[id], levels[roomLevel.id]);

  for (const { id, name, roomHandle } of Object.values(rooms)) {
    const z = roomFloorElevation(rooms[id]);
    const plane = planeByThreePoints(0, 0, z, 1, 0, z, 0, 1, z);
    assertIsNotNullOrUndefined(plane);

    resolvedDatums[id] = {
      name,
      id,
      source: roomHandle,
      plane,
    };
  }

  return {
    resolvedDatums,
  };
}

export default memo(select, generate);
